import { render, staticRenderFns } from "./PageConfigAdmin.vue?vue&type=template&id=6bdd0d1a&scoped=true"
import script from "./PageConfigAdmin.vue?vue&type=script&lang=js"
export * from "./PageConfigAdmin.vue?vue&type=script&lang=js"
import style0 from "./PageConfigAdmin.vue?vue&type=style&index=0&id=6bdd0d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd0d1a",
  null
  
)

export default component.exports